import { FC } from "react";
import { ProductVariant } from "../../../../models/Message";

interface ProductVariantListProps {
  variants: ProductVariant[];
}

const ProductVariantList: FC<ProductVariantListProps> = ({ variants }) => {
  const formatPrice = (price?: string) => {
    if (!price || price === "") return null;
    // Don't double-prefix if price already has Rp
    if (price.match(/^[Rr]p/)) return price;
    return `Rp. ${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  };

  return (
    <div className="product-variant-section">
      <div className="product-variant-label">
        Variants ({variants.length})
      </div>
      {variants.map((variant, idx) => (
        <div key={variant.sku || idx} className="product-variant-row">
          {variant.imageUrl && variant.imageUrl !== "" && (
            <img
              src={variant.imageUrl}
              alt=""
              className="product-variant-image"
            />
          )}
          <div className="product-variant-detail">
            {variant.name && (
              <div className="product-variant-name">{variant.name}</div>
            )}
            <div className="product-variant-sku">SKU: {variant.sku}</div>
          </div>
          <div className="product-variant-meta">
            {variant.price && (
              <div className="product-variant-price">{formatPrice(variant.price)}</div>
            )}
            {variant.stock !== undefined && variant.stock !== null && (
              <div className={variant.stock === 0 ? "product-variant-stock-empty" : "product-variant-stock"}>
                {variant.stock === 0 ? "Habis" : `Stok: ${variant.stock}`}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductVariantList;
